<template>
  <import-charge-all-business-tab lob="Finance" />
</template>

<script>

import ImportChargeAllBusinessTab from '@/views/cargo/v0/Clearing/ImportChargeAllBusiness/importCharge/importChargeAllBusinessTab.vue'

export default {
  name: 'ImportChargeAllBusiness',
  components: { ImportChargeAllBusinessTab }
}
</script>
